import React, {useEffect, useState} from 'react';
import VendorShowComponent from '../../../Components/UserComponents/VendorInfo';

const VendorShowContainer = () => {
  return <VendorShowComponent />;
};

export default VendorShowContainer;
